import { DataSourceAddressAutocompleteQueryProviderProps } from "./data-source-address-autocomplete-query";

export type DataSource_AddressAutocomplete_QueryKeyType = [
  string,
  Omit<DataSourceAddressAutocompleteQueryProviderProps, "useInitialState">
];

const addressAutocomplete_baseKey = `bbnt-data-source-address-autocomplete`;

export const DataSourceAddressAutocomplete_QueryKey = {
  addressAutocomplete: (
    desiredAddress: DataSourceAddressAutocompleteQueryProviderProps
  ): DataSource_AddressAutocomplete_QueryKeyType => {
    const baseQueryKey = addressAutocomplete_baseKey;

    const { ...desiredAddress_cleaned } = {
      ...desiredAddress,
    };

    const queryKey: DataSource_AddressAutocomplete_QueryKeyType = [
      baseQueryKey,
      desiredAddress_cleaned,
    ];

    return queryKey;
  },
};
